import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Modal, Form, Button, Icon } from "semantic-ui-react";
import { insert_advertising, upload_advertising_banner } from "../../utils/requestHelper";
import { useDispatch } from "react-redux";
import { updateAdvertising } from "../../redux/actions";

function removeEmptyStrings(obj) {
  let newObj = {};
  Object.keys(obj).forEach((prop) => {
    if (obj[prop] !== null && obj[prop] !== "") {
      newObj[prop] = obj[prop];
    }
    if (obj[prop] === 0) {
      newObj[prop] = obj[prop];
    }
  });
  return newObj;
}

const NewAdvertising = ({ hide }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [uploadFile, setUploadFile] = useState();
  const [errors, setErrors] = useState({});
  const inputFile = useRef(null);

  const handleOnChange = (e) => {
    const { id, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleOnAddFile = () => {
    inputFile.current.click();
  };

  const handleOnFileChange = async (e) => {
    if (!e.target.files[0]) return;
    if (e.target.files[0].size > 5300000) {
      alert("File is too big!");
      return;
    }
    setUploadFile(e.target.files[0])
  };

  const handleOnSubmit = async () => {
    if (data) {
      let obj = removeEmptyStrings(data);
      let newErrors = {};
      let error = false;
      if (!obj.hasOwnProperty("title")) {
        newErrors.titleError = t("input-error-title");
        error = true;
      }
      if (!obj.hasOwnProperty("subtitle")) {
        newErrors.subtitleError = t("input-error-subtitle");
        error = true;
      }
      if (!obj.hasOwnProperty("content")) {
        newErrors.contentError = t("input-error-content");
        error = true;
      }
      if (!obj.hasOwnProperty("startDate")) {
        newErrors.startDateError = t("input-error-startDate");
        error = true;
      }
      if (!obj.hasOwnProperty("endDate")) {
        newErrors.endDateError = t("input-error-endDate");
        error = true;
      }

      setErrors({
        ...newErrors,
      });
      if (error === false) {
        const result = await insert_advertising(data);
        if (result.success === true) {
          if (uploadFile) {
            const response = await upload_advertising_banner(result.data.id, uploadFile)
            if (response.success)
              dispatch(updateAdvertising(result.data.id, { imageUrl: response.fileUrl }))
          }
          hide();
        }
        navigate(`/advertisings`);
      }
    }
  };

  return (
    <>
      <Modal.Header>{t(`headline-new_advertising`)}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.Input
              id="title"
              error={
                errors.hasOwnProperty("titleError") && {
                  content: errors.titleError,
                }
              }
              onChange={handleOnChange}
              required
              label={t(`input-label-title`)}
              placeholder={t(`input-placeholder-title`)}
            />
            <Form.Input
              id="subtitle"
              error={
                errors.hasOwnProperty("subtitleError") && {
                  content: errors.subtitleError,
                }
              }
              onChange={handleOnChange}
              required
              label={t(`input-label-subtitle`)}
              placeholder={t(`input-placeholder-subtitle`)}
            />
            <Form.TextArea
              required
              rows={12}
              id="content"
              error={
                errors.hasOwnProperty("contentError") && {
                  content: errors.contentError,
                }
              }
              onChange={handleOnChange}
              label={t(`input-label-content`)}
              placeholder={t(`input-label-content`)}
            />

            <Form.Group widths="equal">
              <Form.Input
                id="startDate"
                type="Date"
                error={
                  errors.hasOwnProperty("startDateError") && {
                    content: errors.startDateError,
                  }
                }
                onChange={handleOnChange}
                required
                label={t(`input-label-startDate`)}
                placeholder={t(`input-placeholder-startDate`)}
              />
              <Form.Input
                id="endDate"
                type="Date"
                error={
                  errors.hasOwnProperty("endDateError") && {
                    content: errors.endDateError,
                  }
                }
                onChange={handleOnChange}
                required
                label={t(`input-label-endDate`)}
                placeholder={t(`input-placeholder-endDate`)}
              />
            </Form.Group>

            <Form.Input
              id="imageUrl"
              icon="linkify"
              iconPosition="left"
              onChange={handleOnChange}
              label={t(`input-label-imageUrl`)}
              placeholder={t(`input-placeholder-imageUrl`)}
              actionPosition="right"
              action={
                <>
                  <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={handleOnFileChange} accept=".jpg,.jpeg,.webp,.png"/>
                  <Button primary animated='vertical' onClick={handleOnAddFile} floated='right'>
                    <Button.Content hidden>{t(`button-upload`)}</Button.Content>
                    <Button.Content visible>
                      <Icon name='upload' />
                    </Button.Content>
                  </Button>
                </>
              }
            />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={hide}>
          <Icon name="times" />
          {t(`button-cancel`)}
        </Button>
        <Button onClick={handleOnSubmit} primary>
          <Icon name="check" />
          {t(`button-create`)}
        </Button>
      </Modal.Actions>
    </>
  );
};

export default NewAdvertising;
